import { Hero } from "./Hero";
import { Grid } from "./Grid";
import { Marketing } from "./Marketing";
import { Slider } from "./Slider";

export const Information = () => {
  return (
    <Slider>
      <Grid />
      <Hero />
      <Marketing />
    </Slider>
  );
};
